export const DEPLOYMENT_URL = `/api/agent/deployments`;
export const ADMIN_DEPLOYMENT_URL = `/api/agent/admin/deployments`;
